import { render } from "./AddtionalProductsAndServicePricing.html?vue&type=template&id=57675884&scoped=true"
import script from "./AddtionalProductsAndServicePricing.js?vue&type=script&lang=js"
export * from "./AddtionalProductsAndServicePricing.js?vue&type=script&lang=js"

import "./AddtionalProductsAndServicePricing.css?vue&type=style&index=0&id=57675884&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57675884"]])

export default __exports__